import { Component, OnInit } from '@angular/core';
import { DataHelper } from '@helpers/data.helper';
import { ApiService } from '@services/api.service';

interface ITopLeagues {
  CategoryId: number;
  ExtensionData: any;
  IsoName: string;
  TournamentId: number;
  TournamentName: string;
  TournamentSportEventCount: number;
}
@Component({
  selector: 'top-leagues',
  templateUrl: '../sharedTemplates/top-leagues.component.html',
})
export class TopLeagues implements OnInit {
  topLeaguesData: Array<ITopLeagues> = [];
  constructor(private _ApiService: ApiService, private _DataHelper: DataHelper) {}
  isOpenLeagueMenu = true;
  ngOnInit() {
    this.getTopLeague();
  }

  getTopLeague() {
    this._ApiService
      .getProcTournamentTopResult()
      .then((x: any) => {
        this.topLeaguesData = x;
      })
      .catch(err => console.log('top-leagues', err));
  }

  selectedLeagueData = [];
  mainData = [];
  getMatch(tournament) {
    this.selectedLeagueData = [];
    this.isOpenLeagueMenu = !this.isOpenLeagueMenu;
    const data = {
      TournamentName: tournament.TournamentName,
      TournamentId: tournament.TournamentId,
      CategoryId: tournament.CategoryId,
      CategoryName: tournament.TournamentName,
      SportId: 1,
      SportName: 'Fußball',
    };

    this.selectedLeagueData.push(data);

    this._DataHelper.setLeagueData(this.selectedLeagueData);

    this._DataHelper.setLeftMenuSportData(this.mainData, this._DataHelper.leftMenuSportDayFilter);
  }
}
